var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20266 4.088C2.33433 3.49572 2.66403 2.96605 3.13734 2.58643C3.61065 2.20681 4.19926 1.99995 4.806 2H11.194C11.8007 1.99995 12.3893 2.20681 12.8627 2.58643C13.336 2.96605 13.6657 3.49572 13.7973 4.088L13.8953 4.52933C14.4033 6.81523 14.4033 9.18477 13.8953 11.4707L13.7973 11.912C13.6657 12.5043 13.336 13.034 12.8627 13.4136C12.3893 13.7932 11.8007 14 11.194 14H4.80666C4.19993 14 3.61131 13.7932 3.138 13.4136C2.6647 13.034 2.33499 12.5043 2.20333 11.912L2.10533 11.4707C1.59739 9.18477 1.59739 6.81523 2.10533 4.52933L2.20333 4.088H2.20266Z",
    stroke: "#F3EDF3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 8.66675H5.892C5.892 9.33341 6.54066 10.6667 8.162 10.6667C9.784 10.6667 10.4327 9.33341 10.4327 8.66675H14.3333",
    stroke: "#F3EDF3",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveFilled);
export default __webpack_public_path__ + "static/media/archive-filled.7c0da05d098349a8dfdbe2fd4f5e0862.svg";
export { ForwardRef as ReactComponent };